import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import Landing from "./pages/Landing";
import SuperAdmin from "./pages/SuperAdmin";
import CompanyAdmin from "./pages/CompanyAdmin";
import CustomerPortal from "./pages/CustomerPortal";
import ReferenceForm from "./pages/ReferenceForm";
import { PaymentCancel, PaymentSuccess } from "./pages/PaymentResult";
import SetPassword from "./pages/SetPassword";
import Signup from "./pages/Signup";

const Loading = () => (
  <div className="grid min-h-screen place-items-center bg-slate-50">
    <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-200 border-t-blue-600" />
  </div>
);

function Dashboard() {
  const { user, loading, portal } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Landing />;
  if (user.roles?.includes("super_admin")) return <SuperAdmin />;
  if (user.can_switch_portal) return portal === "company" ? <CompanyAdmin /> : <CustomerPortal />;
  if (user.roles?.includes("company_admin")) return <CompanyAdmin />;
  if (user.roles?.includes("company_user")) return <CompanyAdmin />;
  return <CustomerPortal />;
}

function LoginRoute() {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

function SignupRoute() {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (user) return <Navigate to="/" replace />;
  return <Signup />;
}

export default function App() {
  useEffect(() => {
    document.title = "ConfirmTerms";
  }, []);

  return (
    <AuthProvider>
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route path="/signup" element={<SignupRoute />} />
          <Route path="/reference/:token" element={<ReferenceForm />} />
          <Route path="/setup/:key" element={<SetPassword />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/" element={<Dashboard />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
